import { Component, Element, h, Host, Method, Prop, State } from "@stencil/core";

const hiddenClass = "ux-dropdown__item--hidden";

@Component({
    tag: "ux-filterable-list",
    shadow: true,
    styleUrl: "filterable-list.scss"
})
export class FilterableList {
    /** enables the search field inside the list */
    @Prop({ reflect: true }) readonly filterable: boolean = false;
    /** The placeholder string for the search field */
    @Prop() readonly searchPlaceholder: string = "Search";

    @Element() domNode: HTMLUxFilterableListElement;

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    @State() items: Array<any> = [];
    @State() slotLabels: Array<string> = [];
    @State() filterString = "";

    /** list element that hosts all items */
    private ul: HTMLUListElement = null;

    componentDidLoad() {
        if (this.ul === null) {
            return;
        }
        [].forEach.call(this.ul.children, (child: HTMLElement, i) => {
            const label = child.getAttribute("label");
            if (!child.matches("li")) {
                // wrap child in li element
                const li = document.createElement("li");
                child.parentNode.insertBefore(li, child);
                li.appendChild(child);
            }
            this.slotLabels[i] = label;
        });
    }

    /** returns true when item should be shown according to the filter */
    private isInFilter(itemName: string): boolean {
        return this.filterString.length === 0 || itemName.toLowerCase().includes(this.filterString);
    }

    /** set the Content from outside */
    @Method()
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    async setFilterValues(filterValues: Array<any>) {
        this.items = filterValues;
    }

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    private onFilterChange(event: any) {
        this.filterString = event.target.value.toLowerCase();
        if (this.items.length > 0) {
            return;
        }
        this.slotLabels.forEach((label, i) => {
            const element = this.ul.children[i];
            if (this.isInFilter(label)) {
                element.classList.remove(hiddenClass);
            } else {
                element.classList.add(hiddenClass);
            }
        });
    }

    public render() {
        const filterInput = this.filterable && (
            <div class="ux-list__filter">
                <input
                    class="ux-list__filter-input ux-input"
                    type="text"
                    placeholder={this.searchPlaceholder}
                    onKeyUp={this.onFilterChange.bind(this)}
                />
            </div>
        );
        const hasItems: boolean = this.items.length > 0;

        return (
            <Host>
                {filterInput}
                <ul ref={(el) => (this.ul = el as HTMLUListElement)} class="ux-dropdown__list">
                    <slot />
                    {hasItems &&
                        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
                        this.items.every((item) =>
                            item.assignedNodes()(
                                <li
                                    class={{
                                        [hiddenClass]: !this.isInFilter(item.label)
                                    }}
                                >
                                    <ux-checkbox-list-item label={item.label} value={item.value} />
                                </li>
                            )
                        )}
                </ul>
            </Host>
        );
    }
}
